import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../login/Auth.scss";

import { Box, Grid } from "@mui/material";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import AuthLayout from "./../auth-layout";
import Field from "./../../component/Field";
import { useDispatch } from "react-redux";
import { getOTP, forgetPassword } from "../../store/forgetPasswordSlice";
import { AppDispatch } from "../../store/store";
import Toaster from "../../component/Toaster";
import ActionButton from "../../component/ActionButton";
import { CommonUtil, Product } from "../../util/Utils";

const GetOTP = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [actionProgress, setActionProgress] = useState(false);

  const initialValue: forgetPassword = {
    centerCode: "",
    email: "",
    mobileNo: "",
  };

  const handleSubmit = (values: any) => {
    setActionProgress(true);
    values.productCode =
      Product.ProductCode() && Product.ProductCode()?.toUpperCase();
    dispatch(getOTP(values))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          Toaster.success(undefined, result.payload.data.message);
          navigate("/forgot-password/verify-otp");
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setActionProgress(false);
      });
  };

  return (
    <Box>
      <Grid
        container
        rowSpacing={1}
        className="center main login-module-background"
      >
        <Grid item xs={10} md={10} lg={8}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            className="viewport-height center"
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              className="login-animation-container theme-bg"
            >
              <AuthLayout />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              lg={6}
              className="login-form-container corner-mask"
            >
              <div className="login-padding">
                <div className="logo center">
                  <span className="login-module-brand-icon"></span>
                </div>
                <div>
                  <div className="logo-change-password">
                    <span></span>
                    <h6 className="header">
                      {t("forgetPassword.OTPVerification")}
                    </h6>

                    <div
                      className="default-font-size"
                      style={{ marginTop: "11px" }}
                    >
                      {t("forgetPassword.description")}
                    </div>
                  </div>

                  <Formik
                    initialValues={initialValue}
                    onSubmit={handleSubmit}
                    validationSchema={Yup.object().shape({
                      centerCode: Yup.string().required(
                        `${t("login.centerCode")} ${t("is required")}`
                      ),
                      email: Yup.string()
                        .email(
                          `${t("forgetPassword.emailAddressValidationMsg")}`
                        )
                        .required(
                          `${t("forgetPassword.emailId")} ${t("is")} ${t(
                            "required"
                          )}`
                        ),
                      mobileNo: Yup.string()
                        .required(
                          `${t("forgetPassword.mobileNumber")} ${t("is")} ${t(
                            "required"
                          )}`
                        )
                        .matches(
                          /^[0-9]{10}$/,
                          `${t("forgetPassword.mobileValidationMsg")}`
                        ),
                    })}
                  >
                    {({
                      values,
                      handleChange,
                      handleBlur,
                      errors,
                      touched,
                    }: any) => {
                      return (
                        <Form>
                          <div>
                            <div className="flex-container">
                              <div className="form-label">
                                {t("login.centerCode")}
                              </div>
                              <div className="flex">
                                <div
                                  className={
                                    "text-icon " +
                                    (errors.centerCode && touched.centerCode
                                      ? "error-border"
                                      : "")
                                  }
                                >
                                  <span className="centercode-control-icon"></span>
                                </div>
                                <div className="text-container border-radius">
                                  <Field
                                    className="border-radius"
                                    name="centerCode"
                                    placeholder={t("enterHere")}
                                    value={values.centerCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={
                                      errors.centerCode && touched.centerCode
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="flex-container border-radius">
                              <div className="form-label">
                                {t("forgetPassword.emailId")}
                              </div>
                              <div className="flex">
                                <div
                                  className={
                                    "text-icon " +
                                    (errors.email && touched.email
                                      ? "error-border"
                                      : "")
                                  }
                                >
                                  <span className="email-control-icon"></span>
                                </div>
                                <div className="text-container border-radius">
                                  <Field
                                    className="border-radius"
                                    name="email"
                                    placeholder={t("enterHere")}
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.email && touched.email}
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              className="flex-container"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="form-label">
                                {t("forgetPassword.mobileNumber")}
                              </div>
                              <div className="flex">
                                <div
                                  className={
                                    "text-icon " +
                                    (errors.mobileNo && touched.mobileNo
                                      ? "error-border"
                                      : "")
                                  }
                                >
                                  <span className="mobile-control-icon"></span>
                                </div>

                                <div className="text-container inherit-number-field border-radius">
                                  <Field
                                    className="border-radius"
                                    name="mobileNo"
                                    placeholder={t("enterHere")}
                                    value={values.mobileNo}
                                    onChange={handleChange}
                                    type="number"
                                    onInput={(e: any) =>
                                      CommonUtil.checkLengthHandler(e, 10)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.mobileNo && touched.mobileNo}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <ActionButton
                            label={t("forgetPassword.getOtp")}
                            loading={actionProgress}
                          />
                          <div style={{ marginBottom: "14vh" }}></div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default GetOTP;
